<ng-container
  *ngIf="
    customTemplate;
    else adaptiveImageRules ? adaptivePictureTemplate : defaultPictureTemplate
  "
  [ngTemplateOutlet]="customTemplate"
  [ngTemplateOutletContext]="{ data: pictureData }"
>
</ng-container>

<ng-template #defaultPictureTemplate>
  <picture>
    <source *ngIf="webpSrc" type="image/webp" [srcset]="webpSrc" />
    <source *ngIf="pngSrc" type="image/png" [srcset]="pngSrc" />
    <img
      [attr.id]="imageId"
      [src]="webpSrc || pngSrc"
      [style]="safeStyle"
      [ngClass]="addClass"
      [attr.alt]="altText"
      [attr.loading]="loading"
      [attr.width]="width"
      [attr.height]="height"
      (mouseenter)="mouseEnter()"
      (mouseleave)="mouseLeave()"
  /></picture>
</ng-template>

<ng-template #adaptivePictureTemplate>
  <picture>
    <!-- Source order matters. Create all WEBP sources first then PNG soruces -->
    <ng-container *ngFor="let rule of adaptiveImageRules">
      <source
        *ngIf="rule.webpFile"
        [media]="rule.max ? '(max-width: ' + rule.max + 'px)' : ''"
        [srcset]="rule.webpFile"
        type="image/webp"
      />
    </ng-container>

    <ng-container *ngFor="let rule of adaptiveImageRules">
      <source
        *ngIf="rule.imageMediaFile"
        [media]="rule.max ? '(max-width: ' + rule.max + 'px)' : ''"
        [srcset]="rule.imageMediaFile"
        type="image/png"
      />
    </ng-container>

    <img
      [attr.id]="imageId"
      [src]="pngSrc"
      [attr.alt]="altText"
      [attr.loading]="loading"
      [attr.width]="width"
      [attr.height]="height"
  /></picture>
</ng-template>
